// src/components/MailingList.jsx
export default function MailingList() {
  const onSubmit = (e) => {
    e.preventDefault(); // aquí iría tu lógica para enviar el email
  };

  return (
    <section className="bg-[#F2F5FF]">
      <div
        className="mx-auto max-w-6xl px-6 py-12"
        style={{ fontFamily: "Montserrat, ui-sans-serif, system-ui" }}
      >
        <h2 className="text-center text-2xl md:text-3xl font-extrabold text-gray-900">
          Join Our Mailing List
        </h2>
        <p className="text-center text-gray-600 mt-2">
          Sign up to receive inspiration, product updates, and special offers from our team.
        </p>

        {/* Form */}
        <form onSubmit={onSubmit} className="mt-6 mx-auto w-full max-w-[700px]">
          <div className="flex flex-col md:flex-row items-stretch gap-3 md:gap-0">
            {/* Input */}
            <input
              type="email"
              required
              placeholder="example@gmail.com"
              className="
                flex-1
                h-[58px] md:h-[70px]
                px-4
                bg-white
                border border-[#011C42]
                placeholder-gray-400
                outline-none
                rounded-[3px] md:rounded-l-[3px] md:rounded-r-none
                focus:ring-2 focus:ring-[#011C42]/40
              "
            />

            {/* Button */}
            <button
              type="submit"
              className="
                h-[58px] md:h-[70px]
                px-6 md:w-[160px]
                bg-[#011C42] text-white font-semibold
                border border-[#011C42]
                rounded-[3px] md:rounded-l-none md:rounded-r-[3px]
                hover:opacity-90
                focus:outline-none focus:ring-2 focus:ring-[#011C42]/50
              "
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
